import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "flt-panel"
}
const _hoisted_3 = { class: "flt-panel-head" }
const _hoisted_4 = { class: "flt-head-count" }
const _hoisted_5 = { class: "flt-panel-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_8 = { class: "flt-item-name" }
const _hoisted_9 = {
  key: 0,
  class: "flt-item-count"
}

import { ref, onMounted, onUnmounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiSelectFilter',
  props: {
    options: {},
    modelValue: {},
    placeholder: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const open    = ref(false)
const wrapRef = ref<HTMLElement | null>(null)

function isSelected(id: number | string) { return props.modelValue.includes(id) }

function toggle(id: number | string) {
  const next = isSelected(id) ? props.modelValue.filter(v => v !== id) : [...props.modelValue, id]
  emit('update:modelValue', next)
}

function selectAll() { emit('update:modelValue', props.options.map(o => o.id)) }
function clear()     { emit('update:modelValue', []) }

function onDocClick(e: MouseEvent) {
  if (wrapRef.value && !wrapRef.value.contains(e.target as Node)) open.value = false
}
onMounted(() => document.addEventListener('click', onDocClick))
onUnmounted(() => document.removeEventListener('click', onDocClick))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flt-dropdown-wrap",
    ref_key: "wrapRef",
    ref: wrapRef
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["flt-dropdown-btn", { open: open.value, selected: __props.modelValue.length > 0 }]),
      disabled: !__props.options.length,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (open.value = !open.value), ["stop"]))
    }, [
      _createElementVNode("span", null, _toDisplayString(__props.modelValue.length ? `${__props.modelValue.length} selecionado${__props.modelValue.length > 1 ? 's' : ''}` : __props.placeholder), 1),
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        class: "flt-chevron",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [
        _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
      ], -1))
    ], 10, _hoisted_1),
    _createVNode(_Transition, { name: "dropdown-slide" }, {
      default: _withCtx(() => [
        (open.value && __props.options.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  type: "button",
                  class: "flt-head-btn",
                  onClick: selectAll
                }, "Todos"),
                _createElementVNode("span", _hoisted_4, _toDisplayString(__props.options.length), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "flt-head-btn danger",
                  onClick: clear
                }, "Limpar")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (o) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: o.id,
                    class: _normalizeClass(["flt-item", { checked: isSelected(o.id) }]),
                    onClick: _withModifiers(($event: any) => (toggle(o.id)), ["prevent"])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["flt-checkbox", { checked: isSelected(o.id) }])
                    }, [
                      (isSelected(o.id))
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(o.name), 1),
                    (o.count != null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(o.count), 1))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_6))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})